import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method getProfile
 * @method getPoint
 * @method updateProfile
 * @method updateShippingAddress
 * @method registerUser
 * @method changePassword
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    /**
     * Get user profile.
     * @param {object} strBzbsToken
     * @return {promises} Profile response.
     */
    getProfile: function (strBzbsToken) {
        var strUrl = this.config().bzbs_url + "/profile/me";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    /**
     * Get point.
     * @param {string} strBzbsToken
     * @return {promises} Point response.
     */
    getPoint: function (strBzbsToken) {
        var strUrl = this.config().bzbs_url + "/profile/me/updated_points";
        return BzbsApi.connectBzbsGet(strUrl, strBzbsToken);
    },

    /**
     * Update user profile.
     * @param {string} strBzbsToken
     * @param {object} objProfileInfo
     * @param {object} objProfileAdress
     * @param {string} strExtendJson
     * @param {string} strUploadKey
     * @param {object} objUpload
     * @return {promises} user response.
     */
    updateProfile: function (strBzbsToken, objProfileInfo, objProfileAdress, strExtendJson, strUploadKey, objUpload) {
        var params = {};

        if (strExtendJson)
            params.extendjsonstring = strExtendJson;

        if (objProfileInfo) {
            if (objProfileInfo.strFirstName)
                params.firstname = objProfileInfo.strFirstName;

            if (objProfileInfo.strLastName)
                params.lastname = objProfileInfo.strLastName;

            if (objProfileInfo.strGender)
                params.gender = objProfileInfo.strGender;

            if (objProfileInfo.strBirthDate)
                params.birthdate = objProfileInfo.strBirthDate;

            if (objProfileInfo.strContantNumber)
                params.contact_Number = objProfileInfo.strContantNumber;

            if (objProfileInfo.strEmail)
                params.email = objProfileInfo.strEmail;

            if (objProfileInfo.strNationalIdCard)
                params.idcard = objProfileInfo.strNationalIdCard;

            if (objProfileInfo.strLocale)
                params.locale = objProfileInfo.strLocale;

            if (objProfileInfo.isNotificationEnable)
                params.notification = objProfileInfo.isNotificationEnable;

            if (objProfileInfo.strIncome)
                params.income = objProfileInfo.strIncome;

            if (objProfileInfo.strInterests)
                params.interests = objProfileInfo.strInterests;

            if (objProfileInfo.strReligion)
                params.region = objProfileInfo.strReligion;

            if (objProfileInfo.strMaritalStatus)
                params.maritalstatus = objProfileInfo.strMaritalStatus;

            if (objProfileInfo.strNationality)
                params.nationality = objProfileInfo.strNationality;

            if (objProfileInfo.strHighestEducation)
                params.highesteducation = objProfileInfo.strHighestEducation;

            if (objProfileInfo.strOccupation)
                params.occupation = objProfileInfo.strOccupation;

            if (objProfileInfo.strPassport)
                params.passport = objProfileInfo.strPassport;

            if (objProfileInfo.strDriverLicenseNumber)
                params.driverlicense = objProfileInfo.strDriverLicenseNumber;

            if (objProfileInfo.strDriverLicenseNumber)
                params.displayname = objProfileInfo.strDriverLicenseNumber;
        }

        if (objProfileAdress) {
            if (objProfileAdress.strAddress)
                params.address = objProfileAdress.strAddress;

            if (objProfileAdress.strVillage)
                params.village = objProfileAdress.strVillage;

            if (objProfileAdress.strBuilding)
                params.building = objProfileAdress.strBuilding;

            if (objProfileAdress.strNumber)
                params.number = objProfileAdress.strNumber;

            if (objProfileAdress.strMoo)
                params.moo = objProfileAdress.strMoo;

            if (objProfileAdress.strRoom)
                params.room = objProfileAdress.strRoom;

            if (objProfileAdress.strFloor)
                params.floor = objProfileAdress.strFloor;

            if (objProfileAdress.strSoi)
                params.soi = objProfileAdress.strSoi;

            if (objProfileAdress.strRoad)
                params.road = objProfileAdress.strRoad;

            if (objProfileAdress.strCountryCode)
                params.country_code = objProfileAdress.strCountryCode;

            if (objProfileAdress.strCountryName)
                params.country_name = objProfileAdress.strCountryName;

            if (objProfileAdress.strProvinceCode)
                params.province_code = objProfileAdress.strProvinceCode;

            if (objProfileAdress.strProvinceName)
                params.province_name = objProfileAdress.strProvinceName;

            if (objProfileAdress.strDistrictCode)
                params.district_code = objProfileAdress.strDistrictCode;

            if (objProfileAdress.strDistrictName)
                params.district_name = objProfileAdress.strDistrictName;

            if (objProfileAdress.strSubDistrictCode)
                params.subdistrict_code = objProfileAdress.strSubDistrictCode;

            if (objProfileAdress.strSubDistrictName)
                params.subdistrict_name = objProfileAdress.strSubDistrictName;

            if (objProfileAdress.strZipcode)
                params.zipcode = objProfileAdress.strZipcode;
        }

        var strUrl = this.config().bzbs_url + "/profile/me";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, strUploadKey, objUpload);
    },

    /**
     * Update user shipping address.
     * @param {string} strBzbsToken
     * @param {object} objProfileShippingAddress
     * @return {promises} Profile shipping address.
     */
    updateShippingAddress: function (strBzbsToken, objProfileShippingAddress) {
        var params = {};

        if (objProfileShippingAddress) {
            if (objProfileShippingAddress.strFirstName)
                params.shippingfirstname = objProfileShippingAddress.strFirstName;

            if (objProfileShippingAddress.strLastName)
                params.shippinglastname = objProfileShippingAddress.strLastName;

            if (objProfileShippingAddress.strContactNumber)
                params.shipping_contact_number = objProfileShippingAddress.strContactNumber;

            if (objProfileShippingAddress.strEmail)
                params.shipping_email = objProfileShippingAddress.strEmail;

            if (objProfileShippingAddress.strAddress)
                params.shipping_address = objProfileShippingAddress.strAddress;

            if (objProfileShippingAddress.strZipcode)
                params.shipping_zipcode = objProfileShippingAddress.strZipcode;

            if (objProfileShippingAddress.strProvinceCode)
                params.shipping_province_code = objProfileShippingAddress.strProvinceCode;

            if (objProfileShippingAddress.strProvinceName)
                params.shipping_province_name = objProfileShippingAddress.strProvinceName;

            if (objProfileShippingAddress.strDistrictCode)
                params.shipping_district_code = objProfileShippingAddress.strDistrictCode;

            if (objProfileShippingAddress.strDistrictName)
                params.shipping_district_name = objProfileShippingAddress.strDistrictName;

            if (objProfileShippingAddress.strSubDistrictCode)
                params.shipping_subdistrict_code = objProfileShippingAddress.strSubDistrictCode;

            if (objProfileShippingAddress.strSubDistrictName)
                params.shipping_subdistrict_name = objProfileShippingAddress.strSubDistrictName;
        }

        var strUrl = BzbsApi.apiUrl + "/profile/me/shipping";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params);
    },

    registerUser: function (objRegisterModel, haveOTP, objRegisterOTPModel, objRegisterDeviceInfoModel, objRegisterAddressModel, objRegisterOtherInfoModel) {
        var params = {
            app_id: Vue.bzbsConfig.app_id,
        };

        if (!objRegisterModel) {
            return null;
        }

        if (haveOTP && !objRegisterOTPModel) {
            return null;
        }

        //Basic info.
        if (objRegisterModel.strUsername)
            params.username = objRegisterModel.strUsername;

        if (objRegisterModel.strPassword)
            params.password = objRegisterModel.strPassword;

        if (objRegisterModel.strConfirmPassword)
            params.confirmpassword = objRegisterModel.strConfirmPassword;

        if (objRegisterModel.strFirstname)
            params.firstname = objRegisterModel.strFirstname;

        if (objRegisterModel.strLastname)
            params.lastname = objRegisterModel.strLastname;

        if (objRegisterModel.strEmail)
            params.email = objRegisterModel.strEmail;

        if (objRegisterModel.strContactNumber)
            params.contact_number = objRegisterModel.strContactNumber;

        if (objRegisterModel.strBirthDate)
            params.birthdate = objRegisterModel.strBirthDate;

        if (objRegisterModel.strNationalID)
            params.idcard = objRegisterModel.strNationalID;

        if (objRegisterModel.strGender)
            params.gender = objRegisterModel.strGender;

        //OTP.
        if (objRegisterOTPModel) {
            if (objRegisterOTPModel.strOTP)
                params.otp = objRegisterOTPModel.strOTP;

            if (objRegisterOTPModel.strRefCode)
                params.refcode = objRegisterOTPModel.strRefCode;
        }

        //Device info.
        if (objRegisterDeviceInfoModel) {
            if (objRegisterDeviceInfoModel.strCarrier)
                params.carrier = objRegisterDeviceInfoModel.strCarrier;

            if (objRegisterDeviceInfoModel.strClientVersion)
                params.client_version = objRegisterDeviceInfoModel.strClientVersion;

            if (objRegisterDeviceInfoModel.strOperationSystem)
                params.os = objRegisterDeviceInfoModel.strOperationSystem;

            if (objRegisterDeviceInfoModel.strPlatform)
                params.platform = objRegisterDeviceInfoModel.strPlatform;

            if (objRegisterDeviceInfoModel.strMacAddress)
                params.mac_address = objRegisterDeviceInfoModel.strMacAddress;
        }

        if (objRegisterAddressModel) {
            if (objRegisterAddressModel.strAddress)
                params.address = objRegisterAddressModel.strAddress;

            if (objRegisterAddressModel.strZipcode)
                params.zipcode = objRegisterAddressModel.strZipcode;

            if (objRegisterAddressModel.strProvinceCode)
                params.province_code = objRegisterAddressModel.strProvinceCode;

            if (objRegisterAddressModel.strProvinceName)
                params.province_name = objRegisterAddressModel.strProvinceName;

            if (objRegisterAddressModel.strDistrictCode)
                params.district_code = objRegisterAddressModel.strDistrictCode;

            if (objRegisterAddressModel.strDistrictName)
                params.district_name = objRegisterAddressModel.strDistrictName;

            if (objRegisterAddressModel.strSubDistrictCode)
                params.subdistrict_code = objRegisterAddressModel.strSubDistrictCode;

            if (objRegisterAddressModel.strSubDistrictName)
                params.subdistrict_name = objRegisterAddressModel.strSubDistrictName;

            if (objRegisterAddressModel.strLatitude)
                params.latitude = objRegisterAddressModel.strLatitude;

            if (objRegisterAddressModel.strLongitude)
                params.longitude = objRegisterAddressModel.strLongitude;
        }

        if (objRegisterOtherInfoModel) {
            if (objRegisterOtherInfoModel.strInfo)
                params.info = objRegisterOtherInfoModel.strInfo;

            if (objRegisterOtherInfoModel.strCustomInfo)
                params.custom_info = objRegisterOtherInfoModel.strCustomInfo;
        }

        var strUrl = this.config().bzbs_url + "/auth/register";
        return BzbsApi.connectBzbsPost(strUrl, null, params, null, null);
    },

    /**
     * Change bzbs password
     * @param {string} strBzbsToken
     * @param {string} strCurrent Current password
     * @param {string} strChange New password
     */
    changePassword: function (strBzbsToken, strCurrent, strChange) {
        var params = {
            current: strCurrent,
            change: strChange,
        };

        var strUrl = this.config().bzbs_url + "/profile/me/change_password";
        return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, null, null);
    },
}

